import React from 'react'
import EditorOutputCreator from '../utils/editor-output-creator'
import CartApi from '../utils/cart-api'
import AdobeAnalytics from '../utils/adobe-analytics'
import OrderStore from '../stores/order-store'
import ImageStore from '../stores/image-store'
import UploadStore from '../stores/upload-store'
import Loader from './utils/ope-loader'
import URLMapper from "../utils/url-mapper"
import Timer from "../utils/timer"
import createReactClass from 'create-react-class'


/**
 * This component gets loaded when the customer is done with his order and has
 * pressed the "Add to cart" button
 */
var Finished = createReactClass({
    mounted: false,
    waitingForLinkingUploadsToUser: false,

    getInitialState: function () {
        return {statusMessage: _('Adding cart items. Two more steps...')};
    },

    componentDidMount: function () {
        var instance = this;
        instance.mounted = true;
        instance.try = 0;

        // Make sure all uploads have finished
        var uploadData = UploadStore.getData();

        if (Object.keys(OrderStore.getItems()).length === 0) {
            instance.setState({statusMessage: _('Empty session.')});
            window.location.hash = "";
        } else if (uploadData.totalImagesToUpload > 0 && uploadData.totalImagesToUpload !== uploadData.serverData) {
            // totalImagesUploaded does not represent the final state of file's upload process.
            instance.setState({statusMessage: _('Upload is not finished.')});
            window.location.hash = "/upsale";
        } else {
            //Log analytics data
            AdobeAnalytics.setFinished();
            this.addOrderToCart();
        }

    },
    addOrderToCart: function () {
        const data = UploadStore.getData()
        logToCentralServer("Finish page, upload stats", {
            "totalImagesUploaded": data.totalImagesUploaded,
            "totalImagesToUpload": data.totalImagesToUpload,
            "totalImagesFailed": data.totalImagesFailed,
            "totalImagesRegistered": data.totalImagesRegistered,
            "serverData": data.serverData,
          })

        var instance = this;

        //Create the JSON data that summarizes all of the images and options selected by the customer
        var editorOutputCreator = new EditorOutputCreator();
        var jsonData = JSON.stringify(editorOutputCreator.create(), null);


        //Add the order to the cart
        CartApi.addToCart(jsonData).then(this.doneAddingCartItems).then(this.waitForCartRedirectUrlAndLinkToAnonymous).then(function (cartRedirectLinks) {

            if (instance.mounted) {
                instance.setState({statusMessage: _('Redirecting to cart. Just a moment...')});
            }

            //Since we are redirecting, remove event listener that warns about leaving the page
            window.removeEventListener('beforeunload', global.leavePageWarning);

            AdobeAnalytics.setRedirectingToCart()

            //Redirect to cart
            window.top.location.href = URLMapper.mapToSecure(cartRedirectLinks.href);
        })['catch'](function (err) {
            instance.try++;
            if (instance.try <= 10) {
                // Some error happened. Let's give a user friendly message.
                instance.setState({statusMessage: _("Loading, please wait")});

                // Retry after a few seconds.
                Timer.set("addOrder", function() {
                    instance.addOrderToCart();
                }.bind(instance), instance.try * 10 * 1000 );
            }
            else {
                // Give up.
                displayError(err.message, err);
                instance.setState({statusMessage: err.message});
            }
        });
    },

    doneAddingCartItems: function (cartId) {
        var instance = this;
        return new Promise(function (resolve, reject) {
            if (instance.mounted) {
                instance.setState({statusMessage: _('We’re processing your order. One more step…')});
            }
            resolve(cartId);
        });
    },

    waitForCartRedirectUrlAndLinkToAnonymous: function (cartId) {
        var self = this;
        return new Promise(function (resolve, reject) {

            function checkStatus() {
                CartApi.getStatus(cartId).then(function (status) {
                    if (status.status === "Finished" && self.waitingForLinkingUploadsToUser == false) {
                        resolve(status.links[0]);
                    } else if (status.status === "Failed") {
                        displayError(_("Something went wrong when adding items to cart. See details below."), {
                            cartId: cartId,
                            error: 'Unknown'
                        });
                        reject(_("Something went wrong when adding items to cart. See details below."));
                    } else {
                        Timer.set("redirectURL", function() {
                            checkStatus()
                        }.bind(CartApi, cartId, resolve, self), 1000);
                    }
                });
            }
            checkStatus();
        });
    },

    render: function () {
        return (
            <section>
                <div className="ope-finished-message">
                    {this.state.statusMessage}
                </div>
                <div className="ope-finished-loader">
                    <Loader/>
                </div>
            </section>
        );
    },
    componentWillUnmount: function() {
        this.mounted = false;
    }
});

export default Finished;
